var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelectionOptionEditorIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0013 7.33329H8.0013M4.0013 9.99996H6.66797M8.66785 2.02352C8.66798 2.01568 8.66805 2.00783 8.66805 1.99996C8.66805 1.26358 8.0711 0.666626 7.33472 0.666626H4.66805C3.93167 0.666626 3.33472 1.26358 3.33472 1.99996C3.33472 2.00782 3.33479 2.01567 3.33492 2.0235M8.66785 2.02352C8.65527 2.74903 8.06323 3.33329 7.33472 3.33329H4.66805C3.93954 3.33329 3.34748 2.74902 3.33492 2.0235M8.66785 2.02352C10.1713 2.21093 11.3346 3.4934 11.3346 5.04758V9.33329C11.3346 11.2001 11.3346 12.1336 10.9713 12.8466C10.6517 13.4738 10.1418 13.9837 9.5146 14.3033C8.80156 14.6666 7.86814 14.6666 6.0013 14.6666C4.13446 14.6666 3.20104 14.6666 2.488 14.3033C1.86079 13.9837 1.35086 13.4738 1.03128 12.8466C0.667969 12.1336 0.667969 11.2001 0.667969 9.33329V5.04758C0.667969 3.49334 1.83143 2.21084 3.33492 2.0235",
    stroke: "#DD5ED9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelectionOptionEditorIcon);
export default ForwardRef;